import React, { useState } from 'react'

import { RootZoomWrapper } from '@Core/Components/RootZoom/style'

const options = [
  { value: '1', label: 'A-', data: '.95' },
  { value: '2', label: 'A', data: '1' },
  { value: '3', label: 'A+', data: '1.05' },
]

const RootZoom = () => {
  const [currentZoom, setCurrentZoom] = useState('2')

  const changeLanguageHandler = (value, seletedData) => {
    setCurrentZoom(value)
    document.documentElement.style.setProperty('zoom', seletedData.data)
  }
  return (
    <RootZoomWrapper
      defaultValue={currentZoom}
      onChange={changeLanguageHandler}
      options={options}
    />
  )
}

export default RootZoom
